import { render, staticRenderFns } from "./completeness-check-modal-comment.vue?vue&type=template&id=7c8c8693"
import script from "./completeness-check-modal-comment.vue?vue&type=script&lang=ts"
export * from "./completeness-check-modal-comment.vue?vue&type=script&lang=ts"
import style0 from "./completeness-check-modal-comment.vue?vue&type=style&index=0&id=7c8c8693&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c8c8693')) {
      api.createRecord('7c8c8693', component.options)
    } else {
      api.reload('7c8c8693', component.options)
    }
    module.hot.accept("./completeness-check-modal-comment.vue?vue&type=template&id=7c8c8693", function () {
      api.rerender('7c8c8693', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/completeness-check/completeness-check-details-modal/completeness-check-modal-comments-tab/completeness-check-modal-comment/completeness-check-modal-comment.vue"
export default component.exports